module.exports = __webpack_public_path__ + "static/img/luxiangjilu2.2ce3f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/luxiangjilu2.png
// module id = 31zD
// module chunks = 24